export const formatLinkBlockToUrl = (data) => {
    const linkTo = data?.linkTo;
    let url = '';
    switch (linkTo) {
        case 'email':
            url = 'mailto:' + data[linkTo];
            break;
        case 'anchor':
            url = '#' + data[linkTo];
            break;
        case 'custom_url':
            url = data?.customUrl;
            break;
        case 'file':
            url = data[linkTo]?.url;
            break;
        case 'page':
            url = data[linkTo]?.url;
            break;
        case 'phone':
            url = 'tel:' + data[linkTo];
            break;
    }

    return url;
};

/**
 * Format rent frequency
 * @param {object} frequency
 * @returns {string}
 */
export const formatRentFrequency = (frequency) => {
    switch(frequency){
        case 'WEEKLY':
            return 'p/w';
        case 'MONTHLY':
            return 'p/m';
        case 'ANNUALLY':
            return 'p/y';
        default:
            return;
    }
};

/**
 * Format price to a currency string
 * @param {number} price
 * @param {Intl.NumberFormatOptions} [options]
 * @returns {string}
 */

export const formatPrice = (price, options) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'GBP',
        currencyDisplay: 'symbol',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        ...options
    });
    return formatter.format(Number(price));
};

/**
 * Generic number formatting
 * @param {number} number
 * @param {Intl.NumberFormatOptions} [options]
 * @returns {string}
 */

export const formatNumber = (number, options) => {
    const formatter = new Intl.NumberFormat('en-GB', {
        ...options
    });
    return formatter.format(Number(number));
};

/**
 * Format bedroom / bathroom range
 * @param {number} min
 * @param {number} max
 * @returns {string}
 */

export const formatRoomRange = (min, max) => {
    if (!max && typeof min === 'number') {return min;}
    if (min && max && typeof min === 'number' && typeof max === 'number') {return `${min}–${max}`;}
    else { return '–';}
};


export const formatPageTitle = (page) => {
    if (page.propertyName) {
        let title = page.__typename === 'RentalPropertyPage' ? 'Rent - ' : 'Buy - ';
        title += page.buildingName ? `${page.buildingName}, ` : '';
        title += page.buildingNumber ? `${page.buildingNumber} ` : '';
        title += page.propertyName;
        return title;
    }
    else if (window) {
        return window.document.title;
    }
    return undefined;
};


export const formatPageUri = () => {
    if (window) {
        return window.location.hostname + window.location.pathname;
    }
    return undefined;
};

/**
 * Format banner tag to use either public selling status or status tag
 * @param {string} publicSellingStatus
 * @param {string} statusTag
 * @returns {string}
 */

export const formatTagBanner = (publicSellingStatus, statusTag) => {
    if (publicSellingStatus && ['Short Let', 'Let', 'Sold', 'Under Offer'].includes(publicSellingStatus)) {
        return publicSellingStatus;
    } else {
        return statusTag;
    }
};
